import React, { useEffect, useState } from 'react';
import { DS } from './ds';
import { Logo } from './Visuals';
type View = 'landing' | 'nosotros' | 'faq' | 'blog';
interface HeaderProps {
  onNav: (id: string) => void;
  currentView: View;
}
const navItems = [{
  label: 'Soluciones',
  id: 'soluciones'
}, {
  label: 'Proceso',
  id: 'proceso'
}, {
  label: 'Planes',
  id: 'planes'
}, {
  label: 'Nosotros',
  id: 'nosotros'
}, {
  label: 'Blog',
  id: 'blog'
}] as const;
export function Header({
  onNav,
  currentView
}: HeaderProps) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  // Hero ahora es siempre claro — el header siempre usa colores oscuros
  // Solo cambia el fondo (transparente → frosted glass al hacer scroll)
  const hasBg = scrolled || currentView !== 'landing';
  useEffect(() => {
    const updateScrollState = () => setScrolled(window.scrollY > 24);
    updateScrollState();
    window.addEventListener('scroll', updateScrollState, {
      passive: true
    });
    return () => window.removeEventListener('scroll', updateScrollState);
  }, []);
  return <header style={{
    position: 'fixed',
    inset: '0 0 auto',
    zIndex: 1000,
    background: hasBg ? 'rgba(245,245,245,0.94)' : 'rgba(245,245,245,0.72)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    borderBottom: hasBg ? `1px solid ${DS.color.border}` : '1px solid transparent',
    transition: `all 0.35s ${DS.ease.smooth}`
  }} data-id="element-64" data-mp="2rm19b2nk3u6n">
      <div style={{
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 24px',
      height: '68px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }} data-id="element-65" data-mp="3ad13qjdtlw7b">
        {/* Logo */}
        <button type="button" onClick={() => onNav('top')} style={{
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: 'pointer'
      }} aria-label="Alinova inicio" data-id="element-66" data-mp="1x7n84jhokq9">
          <Logo size="sm" data-id="element-67" data-mp="1wcxngsyn88xv" />
        </button>

        {/* Nav desktop */}
        <nav className="nav-desktop" aria-label="Navegación principal" style={{
        display: 'flex',
        gap: '4px',
        alignItems: 'center'
      }} data-id="element-68" data-mp="1hnrqlbna2ut5">
          {navItems.map(item => {
          const isActive = item.id === currentView;
          return <button key={item.id} type="button" onClick={() => onNav(item.id)} aria-current={isActive ? 'page' : undefined} style={{
            background: isActive ? DS.color.mint : 'none',
            border: 'none',
            fontFamily: DS.font.body,
            fontSize: '14px',
            fontWeight: isActive ? 700 : 500,
            color: isActive ? DS.color.teal : DS.color.tealDeep,
            padding: '8px 16px',
            borderRadius: DS.radius.pill,
            cursor: 'pointer',
            transition: `all 0.2s ${DS.ease.smooth}`
          }} onMouseEnter={e => {
            if (isActive) return;
            e.currentTarget.style.background = DS.color.mint;
            e.currentTarget.style.color = DS.color.teal;
          }} onMouseLeave={e => {
            if (isActive) return;
            e.currentTarget.style.background = 'none';
            e.currentTarget.style.color = DS.color.tealDeep;
          }} data-id="element-69" data-mp="18pg33ihpkd4x">
                {item.label}
              </button>;
        })}

          {/* Separador */}
          <span aria-hidden="true" style={{
          width: '1px',
          height: '18px',
          background: DS.color.border,
          margin: '0 4px'
        }} data-id="element-70" data-mp="1a26017gu8ps3" />

          {/* Botón Ingresar */}
          <a href="https://www.dentaloop.adl.com.co/cloud/paciente" target="_blank" rel="noopener noreferrer" style={{
          fontFamily: DS.font.body,
          fontSize: '14px',
          fontWeight: 600,
          color: DS.color.tealDeep,
          padding: '8px 16px',
          borderRadius: DS.radius.pill,
          border: `1.5px solid ${DS.color.teal}55`,
          textDecoration: 'none',
          cursor: 'pointer',
          transition: `all 0.2s ${DS.ease.smooth}`,
          display: 'flex',
          alignItems: 'center',
          gap: '6px'
        }} onMouseEnter={e => {
          e.currentTarget.style.background = DS.color.mint;
          e.currentTarget.style.borderColor = DS.color.teal;
        }} onMouseLeave={e => {
          e.currentTarget.style.background = 'transparent';
          e.currentTarget.style.borderColor = `${DS.color.teal}55`;
        }} data-id="element-71" data-mp="22xm2wwi956mj">
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none" aria-hidden="true" data-id="element-72" data-mp="t0nvdqdr0ha6">
              <circle cx="6.5" cy="4.5" r="2.5" stroke={DS.color.tealDeep} strokeWidth="1.4" data-id="element-73" data-mp="p16pwwybnk50" />
              <path d="M1.5 11.5c0-2.485 2.239-4.5 5-4.5s5 2.015 5 4.5" stroke={DS.color.tealDeep} strokeWidth="1.4" strokeLinecap="round" data-id="element-74" data-mp="f27fb8tzxefd" />
            </svg>
            Ingresar
          </a>
        </nav>

        {/* Hamburguesa mobile */}
        <button type="button" className="nav-mobile-btn" style={{
        display: 'none',
        flexDirection: 'column',
        gap: '5px',
        background: 'none',
        border: 'none',
        padding: '8px',
        cursor: 'pointer'
      }} onClick={() => setOpen(v => !v)} aria-label="Menú" aria-expanded={open} data-id="element-75" data-mp="17oj5f4nb75i">
          {[0, 1, 2].map(i => <span key={i} style={{
          display: 'block',
          width: i === 2 ? open ? '22px' : '14px' : '22px',
          height: '2px',
          background: DS.color.tealDeep,
          borderRadius: '2px',
          transition: 'all 0.25s',
          transform: open ? i === 0 ? 'rotate(45deg) translateY(7px)' : i === 1 ? 'scaleX(0)' : 'rotate(-45deg) translateY(-7px)' : 'none'
        }} data-id="element-76" data-mp="33wh5pxpv9jvd" />)}
        </button>
      </div>

      {/* Menú mobile */}
      {open && <div style={{
      background: DS.color.ivory,
      borderTop: `1px solid ${DS.color.border}`,
      padding: '12px 24px 24px'
    }} data-id="element-77" data-mp="o5csnok2cpt8">
          {navItems.map(item => {
        const isActive = item.id === currentView;
        return <button key={item.id} type="button" onClick={() => {
          onNav(item.id);
          setOpen(false);
        }} aria-current={isActive ? 'page' : undefined} style={{
          display: 'block',
          width: '100%',
          textAlign: 'left',
          background: 'none',
          border: 'none',
          padding: '14px 0',
          fontFamily: DS.font.body,
          fontSize: '16px',
          fontWeight: isActive ? 700 : 500,
          color: isActive ? DS.color.teal : DS.color.tealDeep,
          cursor: 'pointer',
          borderBottom: `1px solid ${DS.color.border}`
        }} data-id="element-78" data-mp="2ijgz9vktftrh">
                {item.label}
              </button>;
      })}

          <div style={{
        marginTop: '16px'
      }} data-id="element-79" data-mp="18jwcs4r3dmmv">
            <a href="https://www.dentaloop.adl.com.co/cloud/paciente" target="_blank" rel="noopener noreferrer" onClick={() => setOpen(false)} style={{
          display: 'block',
          textAlign: 'center',
          padding: '12px',
          borderRadius: '12px',
          border: `1.5px solid ${DS.color.teal}55`,
          fontFamily: DS.font.body,
          fontSize: '15px',
          fontWeight: 600,
          color: DS.color.tealDeep,
          textDecoration: 'none'
        }} data-id="element-80" data-mp="1dktr268zdwj3">
              Ingresar
            </a>
          </div>
        </div>}
    </header>;
}